// @flow
import type { State } from '../types';

const subStateSelector = (state: State) => state.app;

export const activeSectionSelector = (state: State) => {
    const subState = subStateSelector(state);
    return subState.activeSection;
};

export const targetSelector = (state: State) => {
    const subState = subStateSelector(state);
    return subState.target;
};

export const tisConfigSelector = (state: State) => {
    const subState = subStateSelector(state);
    return subState.tis;
};

export const throttlingIntervalSelector = (state: State) => {
    const tisConfig = tisConfigSelector(state);
    return tisConfig.interval;
};